import * as React from 'react';
import {
  Html5Qrcode,
  Html5QrcodeSupportedFormats,
  Html5QrcodeScanType,
} from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  // TextField,
  // Button,
} from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../../context/DataContext';

let scanner = null;
const scannerElementId = 'html5-qr-code-full-region';
const qrbox = (viewfinderWidth, viewfinderHeight) => {
  // Square QR Box, with size = 80% of the min edge.
  const minEdgeSizeThreshold = 250;
  const edgeSizePercentage = 0.8;
  const minEdgeSize =
    viewfinderWidth > viewfinderHeight ? viewfinderHeight : viewfinderWidth;
  const qrboxEdgeSize = Math.floor(minEdgeSize * edgeSizePercentage);

  if (qrboxEdgeSize < minEdgeSizeThreshold) {
    if (minEdgeSize < minEdgeSizeThreshold) {
      return {
        width: minEdgeSize,
        height: minEdgeSize * 0.2 < 50 ? 50 : minEdgeSize * 0.2,
      };
    } else {
      return {
        width: minEdgeSizeThreshold,
        height:
          minEdgeSizeThreshold * 0.2 < 50 ? 50 : minEdgeSizeThreshold * 0.2,
      };
    }
  }

  return {
    width: qrboxEdgeSize,
    height: qrboxEdgeSize * 0.2 < 50 ? 50 : qrboxEdgeSize * 0.2,
  };
};

const openCamera = (successCallback) => {
  scanner = new Html5Qrcode(scannerElementId, {
    formatsToSupport: [Html5QrcodeSupportedFormats.CODE_128],
  });
  scanner.start(
    { facingMode: 'environment' },
    {
      fps: 10,
      qrbox,
      experimentalFeatures: {
        useBarCodeDetectorIfSupported: true,
      },
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
    },
    successCallback
  );
};

const closeCamera = () => {
  if (scanner) {
    scanner.stop();
    scanner = null;
  }
};

const CheckPage = () => {
  const navigate = useNavigate();
  const { setCustomerInfo, checkImeiAndIDCard } = React.useContext(Context);
  const [imei, setIMEI] = React.useState('');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [isScanning, setIsScanning] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  // const [identityNumber, setIdentityNumber] = React.useState('');

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        身份檢核
      </Typography>
      <Box
        component='form'
        sx={{ px: 3, '& > :not(style)': { my: 1 } }}
        noValidate
        autoComplete='off'
      >
        <FormControl fullWidth variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-imei'>IMEI/SN</InputLabel>
          <OutlinedInput
            id='outlined-adornment-imei'
            type={'text'}
            value={imei}
            onChange={(e) => setIMEI(e.target.value)}
            endAdornment={
              isScanning ? null : (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle imei scanner visibility'
                    onClick={() => {
                      setIsScanning(true);
                      openCamera((decodedText) => {
                        setIMEI(decodedText);
                        setIsScanning(false);
                        closeCamera();
                      });
                    }}
                    edge='end'
                  >
                    <QrCodeScannerIcon />
                  </IconButton>
                </InputAdornment>
              )
            }
            label='IMEI'
          />
        </FormControl>
        {/* Hide for now */}
        {/* <TextField
          fullWidth
          id='client-id'
          label='身分證字號'
          value={identityNumber}
          onChange={(e) => setIdentityNumber(e.target.value)}
        /> */}
        <Box id={scannerElementId} />
        {errorMsg ? (
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant='contained'
          sx={{ width: 168 }}
          // disabled={!imei || !identityNumber}
          disabled={!imei}
          loading={loading}
          onClick={() => {
            setErrorMsg('');
            setLoading(true);
            // navigate('/burglary-insur/spec');
            // Check imei or sn every time
            checkImeiAndIDCard(
              { imei, idCard: '', insureType: '0A' },
              ({ responseCode, responseMsg, checkResult }) => {
                setLoading(false);
                if (responseCode === '000') {
                  if (!checkResult) {
                    setCustomerInfo({ imei }, () => {
                      navigate('/burglary-insur/spec');
                    });
                  } else {
                    console.log('phase 2: jump to final pdf');
                  }
                } else {
                  setLoading(false);
                  setErrorMsg(responseMsg);
                }
              }
            );
          }}
        >
          下一步
        </LoadingButton>
        {/* Test for burglary insurance phase 2 */}
        {/* {process.env.REACT_APP_ENV === 'production' ||
        process.env.REACT_APP_ENV === 'leaguetech-production' ? null : (
          <Button
            color='info'
            variant='contained'
            sx={{ width: 188 }}
            onClick={() => {
              navigate('/burglary-insur/check-pdf-again');
            }}
          >
            測試用下一步到要保書
          </Button>
        )} */}
      </Box>
    </Box>
  );
};

export default CheckPage;
